<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y v-if="user.role.roleName != 'FINANCE_MANAGER'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile
                @click="printAllStockAdjustment('printStockAdjustment')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockAdjustment()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs15 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="serialNo"
                label="Serial No"
                type="text"
                v-model="queryParams.serialNo"
              ></v-text-field>
            </v-flex>
            <v-flex
              sm4
              v-if="
                user.role.roleName == 'ADMIN' ||
                  user.role.roleName == 'FINANCE_MANAGER'
              "
            >
              <v-select
                :items="warehouseList"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.warehouseId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="stockAdjustmentTypeList"
                label="Choose Adjustment Type..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockAdjustmentList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.warehouse.name }}</td>
              <td>{{ props.item.binName }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.serialNo }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn
                  color="primary"
                  @click.stop="reprintStockAdjustmentInvoice(props.item.id)"
                  >REPRINT</v-btn
                >
              </td>
              <td>
                <v-btn color="success" @click.stop="exportExcel(props.item.id)"
                  >EXPORT</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>

      <div
        id="printStockAdjustment"
        style="bsale: 1px solid black; width: 300px"
        v-show="false"
      >
        <div style="text-align: center">
          <p style="font-size: 18px; margin: 1px">Stock Adjustment Report</p>
        </div>
        <br />
        <div style="padding-left: 5px; padding-right: 5px">
          <table
            style="
              font-family: arial, sans-serif;
              border-collapse: collapse;
              width: 100%;
              font-size: 12px;
              border-top: 1px solid black;
            "
          >
            <thead
              style="
                border-bottom: 1px solid black;
                border-top: 1px solid black;
              "
            >
              <tr>
                <th style="text-align: left">Warehouse Name</th>
                <th style="text-align: left">Bin Name</th>
                <th style="text-align: left">Issue Date</th>
                <th style="text-align: left">Issue No</th>
                <th style="text-align: left">Serial No</th>
                <th style="text-align: left">Adjustment Type</th>
                <th style="text-align: left">Description</th>
                <th style="text-align: left">Updated Date</th>
                <th style="text-align: left">Updated By</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in allStockAdjustmentList" :key="index">
                <td>{{ item.warehouse.name }}</td>
                <td>{{ item.binName }}</td>
                <td>
                  {{ item.issueDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ item.issueNo }}</td>
                <td>{{ item.serialNo }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.description }}</td>
                <td>
                  {{ item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ item.updatedBy }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-layout>
    <!-- dialog -->
    <stockAdjustmentExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></stockAdjustmentExcel>
  </v-container>
</template>
<script>
import { stockAdjustmentService } from "../../services/stock-adjustment-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import stockAdjustmentExcel from "../../components/stock-adjustment/StockAdjustmentExcel";

export default {
  name: "stockAdjustmentList",
  components: { stockAdjustmentExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    issueDate: "",
    breadcrumbs: [
      {
        text: "Warehouse Management",
        disabled: true,
      },
      {
        text: "Stock Adjustment",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "actions", sortable: false },
      { text: "Warehouse Name", align: "left", value: "warehouse.name" },
      { text: "Bin Name", align: "left", value: "binName" },
      { text: "Issue Date", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Serial No", value: "serialNo" },
      { text: "Adjustment Type", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
      { text: "Reprint", align: "center", sortable: false },
      { text: "Export", align: "center", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueNo",
      totalItems: 0,
    },
    printAllButtonLoading: false,
    stockAdjustmentList: [],
    allStockAdjustmentList: [],
    warehouseList: [],
    openDialog: false,
    stockAdjustmentTypeList: [
      { label: "----All----", value: "" },
      { label: "DAMAGE", value: "DAMAGE" },
      { label: "LOSS", value: "LOSS" },
      { label: "RE_FOUNDED", value: "RE_FOUNDED" },
    ],
    totalRows: 0,
    queryParams: {
      warehouseId: "",
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      serialNo: "",
      status: "",
      updateUserId: "",
      binIds: [],
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockAdjustmentList();
      },
      deep: true,
    },
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (
      user.role.roleName == "WAREHOUSE_MANAGER" ||
      user.role.roleName == "WAREHOUSE_STAFF" ||
      user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.warehouseId = user.warehouseId;
      if (user.role.roleName == "WAREHOUSE_STAFF") {
        user.selectedBinList.forEach((v) => this.queryParams.binIds.push(v.id));
        //this.queryParams.updateUserId = user.id;
      }
    } else if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.queryParams.warehouseId = user.shop.warehouseId;
    }
    //for deep linking
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.serialNo) {
      this.queryParams.serialNo = this.$route.query.serialNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.getStockAdjustmentList();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-adjustments",
        query: this.queryParams,
      });
      this.getStockAdjustmentList();
    },

    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportAllStockAdjustment() {
      this.printAllButtonLoading = true;
      stockAdjustmentService
        .exportAllStockAdjustmentExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    printAllStockAdjustment(divName) {
      this.printAllButtonLoading = true;
      stockAdjustmentService
        .getAllStockAdjustmentList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allStockAdjustmentList = res.data.stockAdjustmentDTOList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    getStockAdjustmentList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockAdjustmentService
        .getStockAdjustmentList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockAdjustmentList = res.data.stockAdjustmentDTOList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/stock-adjustment/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getStockAdjustmentList();
    },
    onEdit(stockAdjustment) {
      // go to details page
      this.$router.push("/stock-adjustment/" + stockAdjustment.id);
    },
    reprintStockAdjustmentInvoice(id) {
      stockAdjustmentService.printStockAdjustmentInvoice(id).then((res) => {
        var blob = res;
        commonService.showWindowDialog(blob, "invoice-" + id);
      });
    },
    exportExcel(id) {
      stockAdjustmentService
        .exportStockAdjustmentExcel(id)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
